import React from "react";
import { ApiResponseStatistics } from "../../api/types/api-response-statistics";
import { Badge } from "@/components/ui/badge";

export const TaggingStatusIcon: React.FC<{
  status: ApiResponseStatistics["attributes"]["tagging_status"];
}> = (props) => {
  const getStatusConfig = (status: string) => {
    switch (status) {
      case "production":
        return { label: "Production", variant: "default" as const };
      case "trial":
        return { label: "Trial", variant: "secondary" as const };
      case "onboarding":
        return { label: "Onboarding", variant: "outline" as const };
      case "pause":
        return { label: "Paused", variant: "secondary" as const };
      case "priority":
        return { label: "Priority", variant: "default" as const };
      default:
        return { label: status, variant: "outline" as const };
    }
  };

  const { label, variant } = getStatusConfig(props.status);

  return <Badge variant={variant}>{label}</Badge>;
};
